<div id="htmlData">
  <div class="modal-header">
    <!-- <h4 class="modal-title">Hi Resumen Ficha</h4> -->
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-12">
            <h4 class="text-center font15">
              MUNICIPALIDAD PROVINCIAL DEL CUSCO - GERENCIA DEL CENTRO HISTORICO
            </h4>
          </div>
          <div class="col-12">
            <h5 class="text-center font15">
              FICHA DE REGISTRO DE CATALOGACIÓN DE INMUEBLES - ACCESO PÚBLICO
            </h5>
          </div>
        </div>
      </div>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body gchc-ficha">
    <div class="container" id="info_cat_ficha_inmaterial">
      <div class="row">
        <div class="col-md-3 col-sm-6 align-content-end">
          <div class="alert alert-info font-weight-bolder">
            Nro. de Ficha: {{ ficha.nroficha }}
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <table class="table table-striped table-sm table-bordered" style="font-size: 12px;">
            <thead style="font-size: 12px;">
              <tr>
                <th scope="col" colspan="4" class="text-center" style="background-color:#942452;color:white; font-size:12px;"> INFORMACIÓN DE REGISTRO ARQUITECTÓNICO</th>
              </tr>
              <tr>
                <th scope="col" colspan="4" class="text-center" style="background-color:#C6316F;color:white; font-size:12px;"> INFORMACIÓN GENERAL</th>
              </tr>
            </thead>
            <tbody style="font-size: 12px;">
              <tr style="font-size: 12px;">
                <th colspan="2">DECLARADO PATRIMONIO</th>
                <td colspan="2">{{
                  ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                    .declarado_patrimonio
                  }} - {{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .resolucion_patrimonio
                  }}
                </td>
              </tr>
              <tr>
                <th colspan="2">DIRECCIÓN</th>
                <td colspan="2">{{ ficha.direccion }}</td>
              </tr>
              <tr>
                <th colspan="2">BARRIO</th>
                <td colspan="2">{{ ficha.barrio }}</td>
              </tr>
              <tr>
                <th colspan="2">DENOMINACIÓN</th>
                <td colspan="2">{{
                  ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                    .denominacion
                }}</td>
              </tr>
              <tr>
                <th colspan="2">CATEGORIA DE CATALOGACIÓN</th>
                <td colspan="2">
                  <span class="badge badge-warning mx-1">
                    {{
                      ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                        .ficha_catcatalogacion.abreviacion
                    }}
                  </span>
                  <span class="badge badge-warning mx-1">
                    {{
                      ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                        .ficha_catcatalogacion.nombre
                    }}
                  </span>
                </td>
              </tr>
              <tr>
                <th colspan="2">ZONIFICACIÓN</th>
                <td colspan="2"><span class="badge badge-warning">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .categoria_zonificacion
                  }}
                </span></td>
              </tr>
              <tr>
                <th colspan="2">SECTOR DE PARAMETROS</th>
                <td colspan="2"><span class="badge badge-warning">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .ficha_sectorparametro.abreviacion
                  }}
                </span></td>
              </tr>
              <tr>
                <th colspan="2">SECTOR DE GESTIÓN</th>
                <td colspan="2"><span class="badge badge-warning mx-1">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .globales_sectorgestion.abreviacion
                  }}
                </span> /
                <span class="badge badge-warning mx-1">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .globales_sectorgestion.descripcion
                  }}
                </span></td>
              </tr>
              <tr>
                <th colspan="2">FILIACIÓN CULTURAL</th>
                <td colspan="2">
                  <div class="item_list_1" *ngFor="let item of ficha.ficha_fichaseguimientos[0]
                        .iu_arqt_fichaarquitectonica
                        .iu_arqt_fichaarqtdetfiliacionculturals">
                    <div
                      class="badge mx-1"
                      [ngClass]="{
                        'badge-danger': item.ficha_filiacioncultural.nombre == 'R',
                        'badge-warning': item.ficha_filiacioncultural.nombre == 'C',
                        'badge-primary':
                          item.ficha_filiacioncultural.nombre == 'CP',
                        'badge-success': item.ficha_filiacioncultural.nombre == 'PH'
                      }">
                      {{ item.ficha_filiacioncultural.nombre }}
                    </div>
                    <div class="text_desc_mini">
                      {{ item.ficha_filiacioncultural.descripcion }}
                    </div>
                  </div>
                </td>

              </tr>
              <br>
              <tr>
                <th scope="col" colspan="4" class="text-center" style="background-color:#C6316F;color:white; font-size:12px;"> CONTEXTO HISTÓRICO ESPACIAL</th>
              </tr>
              <tr>
                <td colspan="4">{{
                  ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                    .contexto_historico_espacial
                }}</td>
              </tr>
              <tr>
                <th scope="col" colspan="4" class="text-center" style="background-color:#C6316F;color:white; font-size:12px;"> DESCRIPCIÓN GENERAL</th>
              </tr>
              <tr>
                <td colspan="4">{{
                  ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                    .descripcion_general
                }}</td>
              </tr>

              <tr>
                <th colspan="2" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">PLANO UBICACIÓN - BLOQUES</th>
                <th colspan="2" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">FOTOGRAFÍA FACHADA - PRINCIPAL</th>
              </tr>
              <tr>
                <td colspan="2" rowspan="3" class="text-center"><img
                  src="{{ urlServidorPublico }}/registrofotografico/{{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .iu_arqt_arqfotos[0].imagen | slice: 20:100
                  }}" width="400"/>
                </td>
                <td colspan="2" class="text-center"><img
                  src="{{ urlServidorPublico }}/registrofotografico/{{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .iu_arqt_arqfotos[1].imagen | slice: 20:100
                  }}" width="300"/>
                </td>
              </tr>
              <tr>
                <th colspan="2" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">DESCRIPCIÓN</th>
              </tr>
              <tr>
                <td colspan="2" width="350">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arqt_fichaarquitectonica
                      .iu_arqt_arqfotos[1].descripcion
                  }}
                </td>
              </tr>
              <br>
              <tr>
                <th scope="col" colspan="4" class="text-center" style="background-color:#942452;color:white; font-size:12px;"> INFORMACIÓN DE REGISTRO ARQUEOLÓGICO</th>
              </tr>
              <tr>
                <th colspan="4" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">DESCRIPCIÓN</th>
              </tr>
              <tr>
                <td colspan="4">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                      .obsfachada
                  }}
                </td>
              </tr>
              <tr>
                <th colspan="4" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">CONSTUMBRES Y TRADICIONES</th>
              </tr>
              <tr>
                <td colspan="4">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                      .costumbrestradiciones
                  }}
                </td>
              </tr>
              <tr>
                <th colspan="4" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">COLECCIONES SINGULARES</th>
              </tr>
              <tr>
                <td colspan="4">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                      .coleccionessingulares
                  }}
                </td>
              </tr>

              <tr>
                <th colspan="2" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">PLANO UBICACIÓN - BLOQUES</th>
                <th colspan="2" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">FOTOGRAFÍA FACHADA - PRINCIPAL</th>
              </tr>
              <tr>
                <td colspan="2"class="text-center"><img
                  src="{{ urlServidorPublico }}/registrofotografico/{{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                      .iu_arql_fotos[0].imagen | slice: 20:100
                  }}" width="400"/>
                </td>
                <td colspan="2" class="text-center"><img
                  src="{{ urlServidorPublico }}/registrofotografico/{{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                      .iu_arql_fotos[1].imagen | slice: 20:100
                  }}" width="400"/>
                </td>
              </tr>
              <tr>
                <th colspan="2" style="background-color:#5f5a5c;color:white; font-size:12px;" class="text-center">LEYENDA</th>
                <th colspan="2" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">DESCRIPCIÓN</th>
              </tr>
              <tr>
                <td>ESTRUCTURA PREHISPANICA</td>
                <td><span class="badge badge-danger"> Rojo</span></td>
                <td colspan="2" rowspan="3" width="350" class="text-center">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                    .iu_arql_fotos[1].descripcion
                  }}
                </td>
              </tr>
              <tr>
                <td>ESTRUCTURA CON ELEMENTOS ORIGINALES PREHISPANICOS REUTILIZADOS</td>
                <td><span class="badge badge-success"> Verde</span></td>
              </tr>
              <tr>
                <td>ESTRUCTURA INTERVENIDA</td>
                <td><span class="badge badge-info"> Azul</span></td>
              </tr>
              <br>
              <tr>
                <th colspan="4" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">OBSERVACIONES</th>
              </tr>
              <tr>
                <td colspan="4">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                      .obsinterior
                  }}
                </td>
              </tr>
              <tr>
                <th colspan="4" style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">RECOMENDACIONES</th>
              </tr>
              <tr>
                <td colspan="4">
                  {{
                    ficha.ficha_fichaseguimientos[0].iu_arql_fichaarqueologica
                      .recomendaciones
                  }}
                </td>
              </tr>
              <br>
              <tr>
                <th scope="col" colspan="4" class="text-center" style="background-color:#942452;color:white; font-size:12px;"> INFORMACIÓN DE REGISTRO HISTÓRICO</th>
              </tr>
              <tr *ngIf="ficha.ficha_fichaseguimientos[0].iu_historica_fichahistorica">
                <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">FECHA</th>
                <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">PROPIETARIO Y/O ARRENDATARIO</th>
                <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">DESCRIPCIÓN</th>
                <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">FUENTE</th>
              </tr>
              <tr  *ngFor="let item of ficha.ficha_fichaseguimientos[0]
                .iu_historica_fichahistorica.iu_historica_datoshistoricos">
                <td width="100">{{ item.fecha }}</td>
                <td width="200">{{ item.propietario }}</td>
                <td width="400">{{ item.descripcion }}</td>
                <td>{{ item.fuente }}</td>
              </tr>
            </tbody>
          </table>
          <!-- <table class="table table-striped table-sm table-bordered" *ngIf="ficha.ficha_fichaseguimientos[0].iu_historica_fichahistorica">
            <tr>
              <th scope="col" colspan="4" class="text-center" style="background-color:#942452;color:white; font-size:12px;"> INFORMACIÓN DE REGISTRO HISTÓRICO</th>
            </tr>
            <tr>
              <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">FECHA</th>
              <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">PROPIETARIO Y/O ARRENDATARIO</th>
              <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">DESCRIPCIÓN</th>
              <th style="background-color:#C6316F;color:white; font-size:12px;" class="text-center">FUENTE</th>
            </tr>
              <tr *ngFor="let item of ficha.ficha_fichaseguimientos[0]
                .iu_historica_fichahistorica.iu_historica_datoshistoricos">
                <td width="100">{{ item.fecha }}</td>
                <td width="200">{{ item.propietario }}</td>
                <td width="400">{{ item.descripcion }}</td>
                <td>{{ item.fuente }}</td>
              </tr>
          </table> -->
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="openPDF()">
    Imprimir
  </button>
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">
    Cerrar
  </button>
</div>

